/* eslint-disable @typescript-eslint/ban-ts-comment */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { retrieveLaunchParams } from "@tma.js/sdk-react";

import { init } from "app/init";
import { decodeStartappRoute } from "shared/hooks/use-startapp-redirect";

import { App } from "./app/app";

import "app/mockEnv";

// @ts-ignore
window.TelegramGameProxy = {
  receiveEvent: function () {
    //
  },
};

const root = createRoot(document.getElementById("root")!);

const launchParams = retrieveLaunchParams();
const { tgWebAppPlatform: platform, tgWebAppStartParam } = launchParams;

const startappRoute = decodeStartappRoute(tgWebAppStartParam);
if (startappRoute) {
  window.history.replaceState(null, "", startappRoute);
}
const debug =
  (launchParams.tgWebAppStartParam || "").includes("debug") ||
  import.meta.env.DEV;
init({
  debug,
  eruda: debug && ["ios", "android"].includes(platform),
  mockForMacOS: platform === "macos",
})
  .then(() => {
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  })
  .catch((error) => {
    console.error(error);
    root.render(<div>Error</div>);
  });
